import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Home, 
  Calendar, 
  MessageSquare, 
  Trophy,
  HelpCircle,
  Users
} from 'lucide-react';

const MobileNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/programacao', icon: Calendar, label: 'Programação' },
    { path: '/comunicados', icon: MessageSquare, label: 'Comunicados' },
    { path: '/', icon: Home, label: 'Início', isCenter: true },
    { path: '/contato', icon: Users, label: 'Contato' },
    { path: '/quiz', icon: HelpCircle, label: 'Quiz' }
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-t from-white via-white to-gray-50 border-t border-gray-200 shadow-lg z-50 md:hidden">
      <div className="grid grid-cols-5 h-20 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          const isCenter = item.isCenter;
          
          return (
            <motion.button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`relative flex flex-col items-center justify-center space-y-1 transition-all duration-300 rounded-xl mx-1 my-2 px-1 ${
                active 
                  ? isCenter
                    ? 'text-white bg-gradient-to-br from-golden-500 to-golden-600 shadow-lg transform scale-105'
                    : 'text-amazonia-green-600 bg-amazonia-green-50 shadow-md'
                  : isCenter
                    ? 'text-golden-600 hover:text-golden-700 hover:bg-golden-50'
                    : 'text-gray-500 hover:text-amazonia-green-600 hover:bg-gray-50'
              }`}
              whileTap={{ scale: isCenter ? 1.0 : 0.95 }}
              whileHover={{ scale: isCenter ? 1.05 : 1.02 }}
            >
              <Icon className={`${
                isCenter ? 'w-7 h-7' : 'w-5 h-5'
              } transition-all duration-300`} />
              
              {/* Label com tamanho especial para o centro */}
              <span className={`transition-all duration-300 leading-tight text-center block ${
                isCenter ? 'text-[11px] font-semibold tracking-tight' : 'text-[9.5px] font-medium tracking-tight'
              }`}>
                {item.label}
              </span>
              
              {/* Indicador ativo melhorado */}
              {active && (
                <motion.div
                  className={`absolute -top-1 left-1/2 transform -translate-x-1/2 w-1 h-1 rounded-full ${
                    isCenter ? 'bg-white' : 'bg-amazonia-green-600'
                  }`}
                  layoutId="activeIndicator"
                  initial={false}
                />
              )}
              
              {/* Efeito de brilho para o botão central */}
              {isCenter && active && (
                <motion.div
                  className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-xl"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                />
              )}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileNavigation;
